export const LOCATION_COUNT = "LOCATION_COUNT";
export const LOCATIONS = "LOCATIONS";
